import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  HEADER_FILL,
  TABLE_HEADER_FILL,
  mergeRow,
  safeText,
  setCell,
} from "./principle6SheetHelpers";

const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

export const SHEET_NAME = "Action taken on issue";

const SHEET_TITLE =
  "Provide details of corrective action taken or underway on any issues related to anti-competitive conduct by the entity, based on adverse orders from regulatory authorities.";

export function buildActionTakenOnIssueSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });

  ws.getColumn("A").width = 2;
  ws.getColumn("B").width = 2;
  ws.getColumn("C").width = 2;
  ws.getColumn("D").width = 8;
  ws.getColumn("E").width = 24;
  ws.getColumn("F").width = 28;
  ws.getColumn("G").width = 28;

  const rows = sectionC?.principle7?.essentialIndicators?.antiCompetitiveConduct || [];
  const dataRows = Array.isArray(rows) && rows.length ? rows : [{}];

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_7, { mergeEnd: COL_G });

  mergeRow(ws, TITLE_ROW, COL_D, COL_G, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr. No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Name of authority", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_F, "Brief of the case", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_G, "Corrective action taken", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, safeText(item?.name), { align: "left" });
    setCell(ws, row, COL_F, safeText(item?.briefCase), { align: "left" });
    setCell(ws, row, COL_G, safeText(item?.correctiveActions), { align: "left" });
  });

  return ws;
}
